import PropTypes from 'prop-types'
import { useState } from 'react'

import { formatearFecha } from '../../helpers/helper'
import createValidador from '../../hooks/createValidador'
import * as mensajesService from '../../servicios/mensajesService'
import { Responder } from './Responder'
import { Respuesta } from './Respuesta'

const LENGTH_RESPUESTA = 150

const Mensajeria = ({ idPublicacion, mensajes, setMensajes }) => {
  const [texto, setTexto] = useState({})
  const [errores, setErrores] = useState({})

  const usuario = parseInt(localStorage.getItem('idUsuario'))

  const { Validador } = createValidador()

  const esquema = {
    texto: Validador.Kernel.string()
      .trim()
      .required()
      .max(LENGTH_RESPUESTA)
      .label('Mensaje')
      .error((errors) => {
        return Validador.mensaje(errors)
      })
  }

  const handleChange = (e, idMensaje) => {
    const value = e.target.value
    setTexto((prev) => ({ ...prev, [idMensaje]: value }))
    valido(value)
  }

  const valido = (value) => {
    const error = Validador.validarDato(esquema, { texto: value }, 'texto')
    setErrores(error ?? {})
    return !error
  }

  const agregarRespuesta = (mensajes, padreId, nuevaRespuesta) => {
    return mensajes.map((m) => {
      if (m.idMensaje === padreId) {
        return {
          ...m,
          respuestas: [...(m.respuestas || []), nuevaRespuesta]
        }
      }

      if (m.respuestas?.length) {
        return {
          ...m,
          respuestas: agregarRespuesta(m.respuestas, padreId, nuevaRespuesta)
        }
      }

      return m
    })
  }

  const submitRespuesta = async (idRespuesta, value, padre) => {
    if (!padre) {
      return
    }

    const idUsuario = usuario

    const mensajeRes = {
      idMensajePadre: idRespuesta,
      idPublicacion,
      idPedidoItem: padre.idPedidoItem,
      idPresupuesto: padre.idPresupuesto,
      idUsuarioChat:
        idUsuario === padre.idVendedor ? padre.idComprador : padre.idVendedor,
      idComprador: padre.idComprador,
      idVendedor: padre.idVendedor,
      texto: value,
      privado: false
    }

    try {
      await mensajesService.insertar(mensajeRes)

      setMensajes(
        agregarRespuesta(mensajes, idRespuesta, {
          ...mensajeRes,
          idMensaje: Date.now(),
          fechaEscrito: new Date().toISOString()
        })
      )

      setTexto((prev) => ({ ...prev, [`mensaje-${idRespuesta}`]: '' }))
    } catch {
      setMensajes(mensajes)
    }
  }

  return mensajes.length > 0 ? (
    mensajes.map((mensaje) => (
      <div key={mensaje.idMensaje}>
        <p className="text-left ml-3 mt-3 mb-1">
          {mensaje.texto}
          <br />
          <small className="ml-3">
            {formatearFecha(mensaje.fechaEscrito, 'FH', 'hs')}
          </small>
        </p>

        {mensaje.respuestas && mensaje.respuestas.length > 0 ? (
          <Respuesta
            respuesta={mensaje.respuestas}
            usuario={usuario}
            mensaje={mensaje}
            texto={texto}
            errores={errores}
            handleChange={handleChange}
            submitRespuesta={submitRespuesta}
            valido={valido}
          />
        ) : (
          <Responder
            idComprador={mensaje.idComprador}
            idVendedor={mensaje.idVendedor}
            idUsuarioChat={mensaje.idUsuarioChat}
            idMensaje={mensaje.idMensaje}
            usuario={usuario}
            handleChange={handleChange}
            texto={texto}
            errores={errores}
            submitRespuesta={submitRespuesta}
            valido={valido}
            mensaje={mensaje}
          />
        )}
        <hr className="my-3" />
      </div>
    ))
  ) : (
    <p>No hay mensajes</p>
  )
}

Mensajeria.propTypes = {
  mensajes: PropTypes.array.isRequired,
  setMensajes: PropTypes.func.isRequired,
  idPublicacion: PropTypes.number.isRequired,
  esVendedor: PropTypes.bool,
  idVendedor: PropTypes.number
}

export default Mensajeria
